<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :footer="footer" :config="config"
    ref="table">
  </cTable>
</template>

<script>
import { getRiskControl, upload } from "@/api/finance/risk_control";
// import { getCountry } from "@/api/system/country";
import { getAllClient } from "@/api/user/client";
// import { getAgent } from "@/api/tracker/agent";
import { getUser, getOperateService } from "@/api/user/internal";
import cTable from "@/base/common/index";
export default {
  name: "riskControl",
  components: {
    cTable,
  },

  data() {
    const options = [
      {
        label: this.$t("all"),
        value: 0,
      },
      {
        label: this.$t("bill"),
        value: 1,
      },
      {
        label: this.$t("b2bBill"),
        value: 2,
      },
      {
        label: this.$t("hwBill"),
        value: 3,
      },
    ];
    return {
      config: {
        children: true,
        footerCellClassName: 'col-red'
      },
      methods: {
        list: getRiskControl,
        // getCountry,
        getAllClient,
        getUser,
        getOperateService,
        upload,
      },
      modals: {},
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getAllClient")
                ).payload.rows;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "salesman_id",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getUser", {
                    standard: "Salesman",
                  })
                ).payload.rows;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "ownership",
            placeholder() {
              return this.$tz("所属公司");
            },
            component: "Select",
            options: [],
            optionsFn: "getCompanies",
            optionsKey: "",
          },
          {
            key: "branch_cid",
            placeholder() {
              return this.$tz("分公司");
            },
            component: "Select",
            options: [],
            optionsFn: "getCompanies",
            optionsKey: "",
          },
          {
            key: "start_credit_limit",
            placeholder() {
              return this.$tz("最小,额度");
            },
            component: "Input",
          },
          {
            key: "end_credit_limit",
            placeholder() {
              return this.$tz("最大,额度");
            },
            component: "Input",
          },
          {
            key: 'currency',
            placeholder() {
              return this.$tz('币种')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getCurrency',
            optionsKey: '',
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$tz("上传"),
              type: "upload",
              fnName: "upload",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            upload() {
              // 创建按钮, 上传文件
              let btn = document.createElement("input");
              btn.type = "file";
              btn.accept = ".xlsx";
              btn.click();
              btn.onchange = async (e) => {
                let file = e.target.files[0];
                let formData = new FormData();
                formData.append("file", file);
                this.handleRequestMethods("upload", formData, true, true);
              };
            },
            export({ searchForm }) {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("所属公司"),
          minWidth: 110,
          key: "ownership_name",
        },
        {
          name: () => this.$tz("业务"),
          key: "salesman_account",
          minWidth: 110,
        },
        {
          name: () => this.$tz("客户,代码"),
          key: "account",
          minWidth: 110,
        },
        {
          name: () => this.$tz("客户,中文名"),
          key: "shipper_company_cn",
          minWidth: 110,
        },
        {
          name: () => this.$tz("月度"),
          width: 110,
          children: [
            "date_year",
            "prev_year",
            ...Array(12)
              .fill(1)
              .map((_, i) => i + 1),
          ].map((t) => {
            let data = {
              name:
                t === "date_year"
                  ? this.$tz("年份")
                  : t === "prev_year"
                    ? this.$tz("上一年,结余")
                    : this.$tz(t + "月"),
              key: typeof t === "number" ? "month_" + t : t,
              width: 95,
              total: t !== "date_year",
            };
            return data;
          }),
        },
        {
          name: () => this.$tz("电商部,-,总应收款"),
          key: "total_receivable",
          minWidth: 110,
          total: true
        },
        {
          name: () => this.$tz("币种"),
          key: "total_receivable_currency",
          minWidth: 110,
        },
        {
          name: () => this.$tz("额度"),
          key: "credit_limit",
          minWidth: 110,
        },
        {
          name: () => this.$tz("额度,-,总欠款"),
          key: "excess_amount",
          minWidth: 110,
        },
        {
          name: () => this.$tz("上传时间"),
          key: "create_time",
          minWidth: 110,
        },
        {
          name: () => this.$tz("操作人"),
          key: "operate_name",
          minWidth: 110,
        },
        {
          name: () => this.$tz("备注"),
          key: "remarks",
          minWidth: 110,
        },
      ],
    };
  },
};
</script>
